<template>
    <div class="materia-table-box">
        <el-table :data="showTableData" border size="mini" empty-text="暂无物料行信息" :header-cell-style="headerCellStyle"
            :height="pageFlag == 'inquiryDetail'?PAGESIZE.h-360:PAGESIZE.h-280" v-loading="tableLoading"
            >
            <el-table-column prop="rowNo" width="50" label="行号" fixed align="left"> </el-table-column>
            <!-- <el-table-column prop="orgName" label="组织名称" :show-overflow-tooltip="true" width="120">
                <template slot-scope="scope">
                    <el-link type="primary" @click="form=scope.row;drawer = true">
                        {{scope.row.orgName}}
                    </el-link>
                </template>
            </el-table-column> -->
            <!-- <el-table-column prop="wzClassCode" label="物资分类" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <!-- <el-table-column prop="jobNumber" label="工作令号" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <!-- <el-table-column prop="bomPieceNumber" label="BOM件号" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <!-- <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <!-- <el-table-column prop="status" label="状态" :formatter="formatStatus"></el-table-column> -->
          <!--  <el-table-column prop="wzCode" label="物料编码" fixed :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <el-table-column prop="wzName" label="物料名称" fixed :show-overflow-tooltip="true"> </el-table-column>
          <!--
          <el-table-column prop="wzSspce" label="询价规格" :show-overflow-tooltip="true" width="120"> </el-table-column>
          <el-table-column prop="wzModel" label="询价型号" :show-overflow-tooltip="true" width="120"> </el-table-column>
          <el-table-column prop="figueNumber" label="询价图号" :show-overflow-tooltip="true"> </el-table-column>
          -->
          <el-table-column prop="unit" label="计量单位" :show-overflow-tooltip="true" width="50"> </el-table-column>
          <el-table-column prop="num" label="询价数量" :show-overflow-tooltip="true" width="50"> </el-table-column>
          <el-table-column prop="xqDate" label="需求日期" :show-overflow-tooltip="true" width="100"> </el-table-column>
          <!-- <el-table-column prop="fixedPrice" label="限价" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <el-table-column prop="bcExplain" label="询价特殊备注" width="100" :show-overflow-tooltip="true"> </el-table-column>
            <!-- <el-table-column prop="isXqYp" label="需要样品" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <!-- <el-table-column prop="requestNo" label="需求牌号" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="requestState" label="需求状态" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="requestStandard" label="需求标准" :show-overflow-tooltip="true" width="120"> </el-table-column>
            <el-table-column prop="requestSpec" label="需求规格" :show-overflow-tooltip="true" width="120"> </el-table-column> -->
            <el-table-column label="附件" width="90">
                <template slot-scope="scope">
                    <el-tag v-if="!scope.row.src && scope.row.rowNo" type="info">无附件
                    </el-tag>
                    <el-link v-if="scope.row.src" :underline="false" :href="baseURL+scope.row.src" target="_blank">
                        <el-tag type="success">查看附件</el-tag>
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column prop="isConcatTax" label="是否含税" :show-overflow-tooltip="true" width="50"> </el-table-column>
            <el-table-column prop="gysName" v-if="showBJcol" class-name="gys-col" label="供应商" :show-overflow-tooltip="true" min-width="120px"></el-table-column>
            <el-table-column prop="price" v-if="showBJcol" label="单价" class-name="gys-col" width="120">
                <template slot-scope="scope">
                    <span>{{  scope.row.price && scope.row.price<0?'***':scope.row.price }}</span>
                </template>
            </el-table-column>
           <!-- <el-table-column prop="taxRate" label="税率" class-name="gys-col" :show-overflow-tooltip="true" :formatter="formatTaxRate" width="50">

            </el-table-column>
          -->
            <el-table-column prop="amount" v-if="showBJcol" label="金额" class-name="gys-col" width="120">
                <template slot-scope="scope">
                    <span>{{  scope.row.amount && scope.row.amount<0?'***':scope.row.amount }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="isFq" v-if="showBJcol" width="50px" class-name="gys-col" label="是否放弃" align="center">
                <template slot-scope="scope">
                    <span v-if=" !scope.row.hideIsFq && scope.row.isFq=='-999'">*</span>
                    <span v-if=" !scope.row.hideIsFq && scope.row.isFq!='-999'">{{  scope.row.isFq }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="brand" v-if="showBJcol" width="100px" class-name="gys-col" label="品牌"></el-table-column> -->

            <!-- <el-table-column prop="clJhDate" v-if="showBJcol" width="100px" class-name="gys-col" label="承诺送货日期"></el-table-column> -->
            <el-table-column prop="ghZq" v-if="showBJcol" width="50px" class-name="gys-col" label="供货周期">
                <template slot-scope="scope">
                    <span>{{scope.row.ghZq=='-999'?'***':scope.row.ghZq}}</span>
                </template>
            </el-table-column>

          <el-table-column prop="manufacture" v-if="showBJcol" width="100px" class-name="gys-col" :show-overflow-tooltip="true" label="运费模式">
            <template slot-scope="scope">
              <span>{{scope.row.manufacture=='-999'?'***':scope.row.manufacture}}</span>
            </template>
          </el-table-column>

          <el-table-column prop="remark" width="100px" v-if="orderInfo.orderState != 1" class-name="gys-col" label="提货油库">
            <template slot-scope="scope">
              <el-input
                  type="textarea"
                  v-if="isEdit" size="mini"
                  v-model="scope.row.remark"
                  :disabled="scope.row.isFq"
                  :rows="1"
                  class="table-edit-input">
              </el-input>
              <span v-if="!isEdit">{{ scope.row.remark=='-999'?'***':scope.row.remark }}</span>
            </template>
          </el-table-column>

          <!--
          <el-table-column prop="bjExplain" v-if="showBJcol" width="100px" class-name="gys-col" label="付款方式">
              <template slot-scope="scope">
                  <span>{{scope.row.bjExplain=='-999'?'***':scope.row.bjExplain}}</span>
              </template>
          </el-table-column>

          <el-table-column prop="minCgl" v-if="showBJcol" width="100px" class-name="gys-col" label="最小采购量">
              <template slot-scope="scope">
                  <span>{{scope.row.minCgl=='-999'?'***':scope.row.minCgl}}</span>
              </template>
          </el-table-column>
          <el-table-column prop="minBzl" v-if="showBJcol" width="100px" class-name="gys-col" label="最小包装量">
              <template slot-scope="scope">
                  <span>{{scope.row.minBzl=='-999'?'***':scope.row.minBzl}}</span>
              </template>
          </el-table-column>
        -->
            <el-table-column v-if="showBJcol" width="50px"  prop="isTender" class-name="gys-col" label="是否中标">
                <template slot-scope="scope">
                    <el-switch
                        size="mini"
                        v-if="editTender"
                        v-model="scope.row.isTender"
                        active-color="#67c23a"
                        inactive-color="#999">
                    </el-switch>
                    <span v-if="!editTender && !scope.row.hideIsTender&& scope.row.tenderStatus!=1">{{  scope.row.isTender?'是':'否' }}</span>
                </template>
            </el-table-column>
          <!--
            <el-table-column v-if="checkRole('cgy_role')" :show-overflow-tooltip="true" width="120" prop="chooseReason" class-name="gys-col" label="选择理由">
            </el-table-column>
          -->
            <el-table-column v-if="checkRole('cgy_role') || checkRole('pw') || checkRole('leader')" :show-overflow-tooltip="true" width="120" prop="zbjg" class-name="gys-col" label="中标价格">
            </el-table-column>

            <el-table-column v-if="showBJcol" prop="tenderNum" class-name="gys-col" label="中标数量">
                <template slot-scope="scope">
                    <el-input  v-if="editTender" size="mini" v-model="scope.row.tenderNum" @keyup.native="tenderNumChange(scope.row,'tenderNum')" class="table-edit-input"/>
                    <span v-if="!editTender">{{ orderInfo.orderState == 3 && !scope.row.isTender?'':scope.row.tenderNum }}</span>
                </template>
            </el-table-column>

<!--
          <el-table-column v-if="checkRole('cgy_role') || checkRole('pw') || checkRole('leader')" :show-overflow-tooltip="true" width="120" prop="kbsm" class-name="gys-col" label="开标说明">
          </el-table-column>
-->
          <el-table-column prop="gysSrc" v-if="showBJcol" width="100px" class-name="gys-col" label="供应商附件">
            <template slot-scope="scope">
              <el-tag v-if="!scope.row.gysSrc" type="info">无附件
              </el-tag>
              <el-link v-if="scope.row.gysSrc" :underline="false" :href="baseURL+scope.row.gysSrc" target="_blank">
                <el-tag type="success">查看附件</el-tag>
              </el-link>
            </template>
          </el-table-column>

            <el-table-column label="操作" width="90" align="left" fixed="right" v-if="orderInfo && orderInfo.orderState == 1 && checkRole('admin')">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleEdit(scope.row)">修改
                    </el-button>
                    <el-button type="text" size="small" @click="handleDel(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <div class="no-data-list" v-else>暂无物料信息</div> -->
        <el-drawer title="查看详情" :visible.sync="drawer" custom-class="my-el-drawer" :with-header="false" size='60%'>
			<div class="my-el-drawer-body">
				<el-row type="flex" class="app-main-header mg-b15" align="middle">
					<el-col :span="6">
						<div class="router-title">
							<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}预览</span>
						</div>
					</el-col>
					<el-col :span="18" class="app-main-header-btns">
						<el-button type="primary" size="small" @click="handleEdit(form)">编辑
						</el-button>
					</el-col>
				</el-row>
				<el-collapse v-model="activeNames">
					<el-collapse-item name="1">
						<template slot="title">
							<div style="display: flex;align-items: center;">
								<el-divider direction="vertical"></el-divider>
								<span>询价单明细</span>
							</div>
						</template>
						<el-card shadow="hover" style="border: none;">
							<el-descriptions :column="2" :border="true" :colon="false">
								<el-descriptions-item labelClassName="my-descriptions-label" label="组织编码">
									{{form.orgCode}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="组织名称">
									{{form.orgName}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="物资编码">
									{{form.wzCode}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="物资名称">
									{{form.wzName}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="物资分类">
									{{form.wzClassCode}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="物资规格">
									{{form.wzSspce}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="物资型号">
									{{form.wzModel}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="补充说明">
									{{form.bcExplain}}
								</el-descriptions-item>
								<!-- <el-descriptions-item labelClassName="my-descriptions-label" label="参数配置">
									{{form.paramPz}}
								</el-descriptions-item> -->
								<el-descriptions-item labelClassName="my-descriptions-label" label="工作令号">
									{{form.jobNumber}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="BOM件号">
									{{form.bomPieceNumber}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="限价">
									{{form.fixedPrice}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="含税">
									{{form.isConcatTax}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="税率">
									{{form.taxRate}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="需求数量">
									{{form.num}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="物资单位">
									{{form.unit}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="需求日期">
									{{form.xqDate}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="需要样品">
									{{form.isXqYp}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="附件">
									{{form.src}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="创建时间">
									{{form.createTime}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="创建人">
									{{form.createUser}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="状态">
									{{form.status}}
								</el-descriptions-item>
								<el-descriptions-item labelClassName="my-descriptions-label" label="表头id">
									{{form.hId}}
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
					</el-collapse-item>
				</el-collapse>
			</div>
		</el-drawer>
        <EditMateria ref="EditMateriaRef" :orderInfo="orderInfo" @callback="EditMateriaCallback"/>
        <!-- 选择商品 -->
        <SelectGoodNew ref="SelectGoodsNewRef" @callback="SelectGoodsCallback"/>
    </div>
</template>
<script>
import EditMateria from './EditMateria'
import SelectGoodNew from '@/components/SelectGoodNew'
import {
    inquiryDetailList,
    delInquiryDetail,
    commodityById,
    getOrder,
    dingbiaoOrder
} from '@/api/srm/inquiryDetail.js'
export default {
    props:['pageFlag','hId','orderInfo','editTender','showTenderRow'],
    components:{
        EditMateria,SelectGoodNew
    },
    computed:{
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
        userRoles:function(){
            return this.$store.getters['user/roles'];
        },
        showBJcol:function(){
            return !this.checkRole('gys_role') && this.orderInfo.orderState>=3;      // 待定标状态
        },
        showTableData:function(){
            return this.tableData
        },
    },
    data(){
        return {
            drawer:false,
            tableLoading:false,
            quertInfo: {
                page: 1, //当前页码
                limit: 2000, //当前每页显示的数量
                objMap: {
                    orderId: this.hId,
                }
            },
            activeNames: ['1'],
            form: {},
            tableData:[],
        }
    },
    created(){
        this.getList();
    },
    mounted(){

    },
    methods:{
        SelectGoodsCallback(obj){
            if(obj.type == 'add'){
                console.log(obj.data)
                let goodsObj = {
                    ...obj.data,
                    id:undefined,
                    goodsId:obj.data.id, // 物料id
                    code:obj.data.code, // 物料编码
                    name:obj.data.name, // 物料名称
                    classifyName:obj.data.classifyName, // 物料类别
                    classifyCode:obj.data.classifyCode, // 物料类别编码
                    sspace:obj.data.sspace, // 规格
                    model:obj.data.model, // 型号
                    unit:obj.data.unit, // 单位
                    isConcatTax:this.orderInfo.isConcatTax, // 是否含税
                }
                this.$refs.EditMateriaRef.handleEdit(goodsObj,'新增物料','add');
            }
        },
        EditMateriaCallback(obj){
            if(obj.type=='getlist'){
                this.getList();
                this.$refs.SelectGoodsNewRef.openDialog = false;
            }
        },
        addMateria(){
            this.$refs.SelectGoodsNewRef.init(this.tableData);
        },
        async getList() {
            let _this = this;
            this.tableLoading = true;
            const {
                data: res
            } = await inquiryDetailList(_this.quertInfo)

            if (res.code == 0) {
                if(_this.showBJcol){
                    _this.getFinalOrderFun(res.data); // 获取定标数据
                }else{
                    this.tableLoading = false;
                    _this.tableData = res.data;
                    _this.tableData.forEach((good,goodIndex)=>{
                        good['rowNo'] = goodIndex+1;
                    })
                }
            }else{
                this.tableLoading = false;
            }
        },
        formatStatus: function(row) {
            return row.status == 0 ? '启用' : '禁用';
        },
        // 删除
        handleDel: function(id) {
            let _this = this;
            _this.confirm({
                text: '确认删除吗',
                tip: '警告',
                type: '',
                fn: function(param) {
                    delInquiryDetail(param).then(response => {
                        if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.getList();
                        } else {
                            _this.$fail(response.data.msg);
                        }
                    });
                },
                data: { id: id } //参数对象 主要回调函数用
            });
        },
        // 编辑
        handleEdit:function(row){
            console.log(row)
            let goodsObj = {
                id:row.id,
                goodsId:row.commodityId, // 物料id
                code:row.wzCode, // 物料编码
                name:row.wzName, // 物料名称
                // classifyName:row.classifyName, // 物料类别
                // classifyCode:row.classifyCode, // 物料类别编码
                sspace:row.wzSspce, // 规格
                model:row.wzModel, // 型号
                unit:row.unit, // 单位
                isConcatTax:this.orderInfo.isConcatTax, // 是否含税
            }
            console.log({...row,...goodsObj})
            commodityById({id:row.commodityId}).then(({data:res})=>{
                console.log(res)
            })
            // return
            // commodityById
            this.$refs.EditMateriaRef.handleEdit({...row,...goodsObj},'修改物料','edit')
        },
        formatTaxRate: function(row) {
            if(row.taxRate == '-999'){
                return '***'
            }
            if(row.taxRate || row.taxRate == 0){
                return row.taxRate+'%';
            }else{
                return ''
            }

        },
        // 获取定标数据
        getFinalOrderFun(goods){
            this.tableLoading = true;
             getOrder({id:this.orderInfo.id}).then(({data: res})=>{
                this.tableLoading = false;
                if(res.code == 0){
                    this.finalPushTable(goods,res.data)
                }
            })
        },
        // 将定标数据插入物料行
        finalPushTable(goods,datas){
            let _this = this;
            let newTableData = [];
            // console.log(goods)
            goods.forEach((good,goodIndex)=>{ // 物料行
                let rowInfo = null;
                let goodObj = {...good,goodIndex:`goodIndex_${goodIndex}`};
                goodObj['rowNo'] = goodIndex+1;
                goodObj['tenderStatus'] = 1;
                // goodObj['chooseReason'] = ''
                goodObj['zbjg'] = '';
                goodObj['kbsm'] = '';
                goodObj['figueNumber'] = ''
                // console.log(good)
                datas.forEach((tgood)=>{
                    // if(tgood.commodityName == good.wzName){  // 物料id判断
                    if(tgood.inquiryDetail.id == good.id){  // 物料id判断
                        goodObj['figueNumber'] = tgood.commodity.figueNumber
                        if(this.showTenderRow){
                            // 这里过滤掉未中标的供应商
                            let gysList = tgood.gysInfoList||[];
                            console.log(gysList)
                            let newList = [];
                            gysList.forEach((g)=>{
                                if(g&&g.inquiryDetailUser&&g.inquiryDetailUser.status == 2){
                                    newList.push(g)
                                }
                            })
                            if(newList.length>0){
                                rowInfo = {
                                    gysInfoList:[...newList]
                                }
                            }
                        }else{
                            rowInfo = tgood
                        }
                    }
                })
                // console.log(rowInfo)
                if(rowInfo){
                    let gysList = rowInfo.gysInfoList || [];
                    // showTenderRow // 是否中标
                    gysList.forEach((item,index)=>{   // 定标数据行
                        let gysObj = {
                            gysName:item.supplierInfo && item.supplierInfo.name?item.supplierInfo.name:''
                        };
                        let bjInfo = item.inquiryDetailUser;
                        let obj = {};
                        if(bjInfo){
                            console.log('bjInfo================')
                            console.log(bjInfo)
                            obj = {
                                backId:bjInfo.id,                   //
                                orderId:bjInfo.orderId,                   //
                                detailId:bjInfo.detailId,                   //
                                price:bjInfo.price,                   // 单价
                                amount:bjInfo.amount,                   // 金额
                                isFq:bjInfo.isFq,           // 是否放弃
                                // brand:bjInfo.brand,                   // 品牌
                                manufacture:bjInfo.manufacture,       // 制造厂商
                                // clJhDate:bjInfo.clJhDate,             // 承诺送货日期
                                ghZq:bjInfo.ghZq,                     // 供货周期
                                bjExplain:bjInfo.bjExplain,           // 报价说明
                                effectivePeriod:bjInfo.effectivePeriod,           // 报价有效期
                                bjwlmc:bjInfo.bjwlmc,           // 报价物料名称
                                bjgg:bjInfo.bjgg,           // 报价规格
                                bjxh:bjInfo.bjxh,           // 报价型号
                                bjth:bjInfo.bjth,           // 报价图号
                                taxRate:bjInfo.taxRate,           // 报价图号
                                remark:bjInfo.remark,           // 特殊备注
                                minCgl:bjInfo.minCgl,                 // 最小采购量
                                minBzl:bjInfo.minBzl,                 // 最小包装量
                                gysSrc:bjInfo.gysSrc,                 // 供应商附件
                                isTender:bjInfo.status==2,                 // 是否中标
                                tenderStatus:bjInfo.status,                 // 是否中标原始数据
                                tenderNum:bjInfo.zbsl!='-999'?bjInfo.zbsl||'':'',                 // 中标数量
                                bjnum:bjInfo.num||'',                 // 报价数量
                            };
                            if(obj.isTender){   // 中标
                                // obj['chooseReason']=bjInfo.chooseReason||'';    // 选择理由
                                obj['zbjg']=bjInfo.zbjg||'';    // 中标价格
                                obj['kbsm']=bjInfo.kbsm||'';    // 开标说明
                            }
                        }else{
                            obj['orderId'] = rowInfo.inquiry.id;
                            obj['hideIsTender'] = true
                            obj['hideIsFq'] = true
                        }

                        if(index == 0){
                            goodObj = {...goodObj,...gysObj,...obj,bjOldNum:goodObj.num};
                            newTableData.push(goodObj)
                        }else{
                            newTableData.push({...gysObj,...obj,goodIndex:`goodIndex_${goodIndex}`,bjOldNum:goodObj.num})
                        }
                    })

                }else{
                    newTableData.push(goodObj)
                };
            });
            console.log(newTableData)
            if(this.showTenderRow){ // 仅显示中标行
                let tList = []
                newTableData.forEach((n) => {
                    if(n.isTender){
                        tList.push(n)
                    }
                })
                _this.tableData = [...tList];
            }else{
                _this.tableData = newTableData;
            }
        },
        // 整数
        tenderNumChange(row,prop){
            let curVal = row[prop];
            if(curVal){
                curVal = curVal.replace(/[^\.\d]/g, '')
                curVal = curVal.replace('.', '')
            }
            row[prop] = curVal;
        },
        // 确认定标
        saveTender(datas){
            let _this = this;
            let dbData = [];
            let error = '';
            let tenderNumObj = {};
            let editData = []
            if(datas){
                editData = [...datas.data]
            }else{
                editData = [...this.tableData]
            }
            console.log(editData)
            let tenderObj={}
            let wzName = '', tenderNoZbjg = null;        // 是否中标未填中标价格
            editData.forEach((item)=>{
                // console.log(item)
                // console.log(item.goodIndex)

                if(item.wzName){
                    wzName = item.wzName
                }
                // 查看中标行中标数量和是否大于询价数量
                if(!tenderObj[item.goodIndex]){
                    tenderObj[item.goodIndex] = {
                        wzName:'',
                        hasTender:false,
                        haskbsm:true,   // 是否填写了开标说明
                        allNum:null,    // 询价数量
                        rowTenderNum:0
                    }
                }
                if(item.num && !tenderObj[item.goodIndex].allNum){
                    tenderObj[item.goodIndex].allNum = item.num;
                }
                if(item.wzName && !tenderObj[item.goodIndex].wzName){
                    tenderObj[item.goodIndex].wzName = item.wzName
                }
                if(item.isTender){
                    tenderObj[item.goodIndex].hasTender = true;
                    tenderObj[item.goodIndex]['rowTenderNum']= tenderObj[item.goodIndex]['rowTenderNum'] + Number(item.tenderNum);
                    if(!item.kbsm){
                        tenderObj[item.goodIndex]['haskbsm'] = false
                    }
                    if(!tenderNoZbjg && !item.zbjg){
                        tenderNoZbjg = {
                            gysName:item.gysName,
                            wzName:wzName
                        }
                    }
                }
                let obj = {
                    id:item.backId,                     // 物料行id
                    orderId:item.orderId,          // 订单id
                    status:item.isTender?2:3,            // 2中标 3未中标
                    // num:item.isTender&&item.tenderNum!=''?parseInt(item.tenderNum):0,     // 中标数量
                    zbsl:item.isTender&&item.tenderNum!=''?parseInt(item.tenderNum):0,     // 中标数量
                    // chooseReason:item.isTender?item.chooseReason:'',     // 选择理由
                    zbjg:item.isTender?item.zbjg:'',     // 中标价格
                    kbsm:item.isTender?item.kbsm:'',     // 开标说明
                };
                if(!error){
                    if(item.isTender){
                        if(!item.tenderNum ){
                            error = `供应商:“${item.gysName}”中标物料的中标数量填写有误，请检查`
                        }
                        // else if(item.tenderNum&&item.tenderNum>item.num){
                        //     error = `供应商:“${item.gysName}”的中标数量大于询价数量，请检查`
                        // }
                    }
                }
                dbData.push(obj)
            });
            if(error){
                console.log('-----')
                console.log(error)
                this.$warn(error)
                return
            }
            console.log(tenderObj)
            console.log(dbData)
            // 判断定标数量是否等于询价数量
            let tnBigAll = '';
            let noBalanceName = ''
            let balance = true, hasNoKbsm = false;
            for (let key in tenderObj) {
                if(tenderObj[key]['allNum'] != tenderObj[key]['rowTenderNum'] && tenderObj[key]['hasTender']){ // 定标数总和不等于询价数
                    balance = false
                    noBalanceName = tenderObj[key].wzName;
                }
                // if(tenderObj[key]['allNum'] < tenderObj[key]['rowTenderNum']){
                //     tnBigAll = `物料：${tenderObj[key].wzName} 供应商中标数量总和的超过询价数量，请检查`
                // }
                if(!tenderObj[key]['haskbsm']){ // 存在未填写开标说明的行
                    hasNoKbsm = true
                }
            }
            if(!tnBigAll && tenderNoZbjg){
                tnBigAll = `物料：${tenderNoZbjg.wzName} 供应商 ${tenderNoZbjg.gysName}中标未填写中标价格，请检查`
            }
            if(tnBigAll){
                this.$warn(tnBigAll)
                return
            }
            let paramer ={
                inquiryDetailUsers:dbData,
                dingbiaoRemark:datas.dbremark,
                justSave:false
            }
            if(datas.type==3){  // 暂存
                // console.log('暂存')
                // console.log(dbData)
                paramer['justSave'] = true;
                dingbiaoOrder(paramer).then(({data:res})=>{
                    if(res.code == 0){
                        _this.$success('暂存成功');
                        _this.$emit('callback',{type:'tenderSuc',hasDatas:datas});
                    }
                })
                return
            }
            // if(!balance && hasNoKbsm){  // 定标数总和不等于询价数 并且定标行没有写开标说明的
            if(!balance){  // 定标数总和不等于询价数
                // _this.$confirm('中标数量相加不等于需求数量，请在“开标说明”处写明原因！', '提示', {
                _this.$confirm(`${noBalanceName}物料需求数量之和不等于中标数量，请在开标说明处写明原因！`, '提示', {
                    confirmButtonText: '继续保存',
                    cancelButtonText: '返回填写',
                    type: 'warning'
                }).then(() => {
                    dingbiaoOrder(paramer).then(({data:res})=>{
                        if(res.code == 0){
                            _this.$success('保存成功');
                            _this.$emit('callback',{type:'tenderSuc',hasDatas:datas});
                        }
                    })
                }).catch(() => {

                });
                return
            }
            _this.confirm({
                text: '是否确认定标？',
                tip: '提示',
                type: 'info',
                fn: function(param) {
                    dingbiaoOrder(param).then(({data:res})=>{
                        if(res.code == 0){
                            _this.$success('保存成功');
                            _this.$emit('callback',{type:'tenderSuc',hasDatas:datas});
                        }
                    })
                },
                data: paramer //参数对象 主要回调函数用
            });
        },
    },
    watch:{
        showTenderRow:function(){
            this.getList()
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep.el-table{
    .gys-col{
        background: #ecf5ff;
    }
}
.no-data-list{
    width: 100%;
    text-align: center;
    line-height: 200px;
    color: #999;
}
</style>


